var React = require('react');

function Question (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10.5","cy":"10.5","r":"10","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M9.371 12.134c0-.713.08-1.274.242-1.684.16-.415.422-.774.784-1.077.36-.303.634-.579.82-.828.19-.254.285-.532.285-.835 0-.737-.317-1.106-.952-1.106a.883.883 0 00-.71.323c-.18.215-.276.505-.286.871H7.08c.01-.976.317-1.736.922-2.277.606-.547 1.456-.82 2.55-.82 1.088 0 1.93.25 2.526.754.6.503.901 1.218.901 2.146 0 .405-.08.774-.242 1.106-.16.332-.42.67-.776 1.018l-.842.783c-.24.23-.406.467-.498.71-.093.24-.144.545-.154.916H9.37z","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"10.5","cy":"15.411","r":"1.5","fill":"currentColor","key":2})]);
}

Question.defaultProps = {"viewBox":"0 0 21 21","fill":"none"};

module.exports = Question;

Question.default = Question;
